import { render, staticRenderFns } from "./freeJobInfo.vue?vue&type=template&id=313eeda3"
import script from "./freeJobInfo.vue?vue&type=script&lang=js"
export * from "./freeJobInfo.vue?vue&type=script&lang=js"
import style0 from "./freeJobInfo.vue?vue&type=style&index=0&id=313eeda3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports